

export class UpdateSubMenuInput implements IUpdateSubMenuInput {
    /** The auto-generated id of the tbl_application_sub_menu */
    applicationSubMenuId!: number;
    /** The sub menu name with 100 character limit */
    menuName!: string;
    /** The sub menu icon with 2048 character limit */
    menuURL!: string;
    /** The sub menu type must be "OVERVIEW" or "DETAIL" */
    screenType!: string;
    /** The index_number */
    indexNumber!: number;

    constructor(data?: IUpdateSubMenuInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationSubMenuId = _data["applicationSubMenuId"];
            this.menuName = _data["menuName"];
            this.menuURL = _data["menuURL"];
            this.screenType = _data["screenType"];
            this.indexNumber = _data["indexNumber"];
        }
    }

    static fromJS(data: any): UpdateSubMenuInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubMenuInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationSubMenuId"] = this.applicationSubMenuId;
        data["menuName"] = this.menuName;
        data["menuURL"] = this.menuURL;
        data["screenType"] = this.screenType;
        data["indexNumber"] = this.indexNumber;
        return data; 
    }
}

export interface IUpdateSubMenuInput {
    /** The auto-generated id of the tbl_application_sub_menu */
    applicationSubMenuId: number;
    /** The sub menu name with 100 character limit */
    menuName: string;
    /** The sub menu icon with 2048 character limit */
    menuURL: string;
    /** The sub menu type must be "OVERVIEW" or "DETAIL" */
    screenType: string;
    /** The index_number */
    indexNumber: number;
}

